<template>

<div class='row'>

    <loading-div v-if='!isReady'></loading-div>

    <div class='col-12' v-if='canStart && isReady'>

        <div class="add-new-tender">

            <h6 class="d-flex justify-content-center align-items-center">
                <span class="icon icon-add mr-2"></span>
                <span class="text-left">
                    Като ръководител на проекта, <br>
                    вие може да стартирате тръжни процерури.
                </span>
            </h6>

            <button @click='showForm = !showForm' class='btn btn-lg btn-primary'>
                <span class="icon icon-plus-circle mr-2"></span>
                Започни нова процедура
            </button>
            
        </div>
        

        <div class="row mb-3" v-show='showForm'>
            <div class="col-12 form-group">
                <label for='rid'>Моля изберете тръжна процедура</label>
                <select id='rid' class='form-control' type="text" v-model='newPhase.rid'>
                    <option v-for='p in phList' :value='p.id'>{{ p.name }}</option>
                </select>
            </div>
            <div class="col-12 form-group">
                <label for='days'>Продължителност на търга ( брой дни )</label>
                <input id='days' class='form-control' type="text" v-model.number='newPhase.days'>
            </div>
            <div class="col-12 form-group">
                <label for='info'>Информация</label>
                <textarea id='info' class='form-control summernote' v-model.trim='newPhase.info'></textarea>
            </div>

            <div @click='startPhase' class='col-12'>
                <form-validator ref='validator' :fields='validatorFields'></form-validator>
                <button class='btn btn-info'>
                    Стартирай тръжната процедура
                </button>
            </div>
        </div>

    </div>

    <div v-if='page == "list"' class="col-12">

        <h3 class="fieldset-title text-left mb-4">Стартирани процедури:</h3>

        <div v-for='tp in subPhases' class="tenders container-fluid ">
            
            <div class="row pos-rel mb-4">
                <div class="col-12 tenders-title">
                    <h4 class="mb-1">
                        <a @click='openTP( tp )' > {{ tp.name }} </a>
                    </h4>
                </div>

                <div class="col-12 tenders-status">
                      
                    Статус:   
                    <strong v-if='!tp.offer_id'>Все още няма избран изпълнител</strong>
                    <strong v-if='tp.offer_id'>Има избран изпълнител</strong>

                </div> 

                <img v-if='tp.offer_id' src="/resources/images/check.svg" alt="Logo Videa" class="logo-check">
            </div>

            <div class="row tender-params">

                <div class="tender-date col-12 col-sm-6 col-lg-3 d-flex align-items-center mb-4">
                    <span class="icon icon-calendar-start mr-2"></span> 
                    <span>
                        <span class="param-label">Начало:</span> 
                        <span class="param-val"> {{  dateOnly( tp.start_date ) }} </span>
                    </span>
                </div> 

                <div class="tender-date col-12 col-sm-6 col-lg-3 d-flex align-items-center mb-4">
                    <span class="icon icon-calendar-end mr-2"></span> 
                    <span>
                        <span class="param-label">Край:</span> 
                        <span class="param-val"> {{  dateOnly( tp.end_date ) }} </span>
                    </span>
                </div> 

                <div class="tender-date col-12 col-sm-6 col-lg-3 d-flex align-items-center mb-4">
                    <span class="icon icon-users mr-2"></span> 
                    <span>
                        <span class="param-label">Преглеждания:</span> 
                        <span class="param-val"> {{ tp.previews }} </span>
                    </span>
                </div> 

                <div class="tender-date col-12 col-sm-6 col-lg-3 d-flex align-items-center mb-4">
                    <span class="icon icon-flag mr-2"></span> 
                    <span>
                        <span class="param-label">Оферти:</span> 
                        <span class="param-val"> {{ tp.offers }} </span>
                    </span>
                </div> 

            </div>
            
            <button @click='openTP( tp )' class='btn btn-info vue-link'>
                Преглед
                <span class="icon icon-chevrons-right icon-after"></span> 
            </button>
               
        </div>



        <div v-if='isReady && !subPhases.length' class='alert alert-info col-12'>
            До момента няма стартирани тръжни процедури
        </div>
    </div>

    <div v-if='page == "single"'  class='col-12 mt-3'>
        <button class='btn btn-info' @click='page = "list"'>
            <span class="icon icon-chevron-left mr-12"></span>
            <span class="icon icon-chevron-left"></span>
            Назад
        </button>

        <h4 class="text-center mb-0">Преглед на тръжна процедура:</h4>
        <h2> "{{ tp.name }}" </h2>

        <div class="container-fluid">
            <div class="row">
                <div class='col-12'>
                    
                    <p v-html='tp.desc'></p>

                    <div v-if='!tp.offer_id' class="auction-item shadow mt-2 mb-3 p-5">
                        <phase-timer :end='tp.end_date' :msg='timerMessage'></phase-timer>
                    </div>

                    <div class='alert alert-info' v-if='tp.offer_id'>
                        <span class="icon icon-cup"></span>
                        Има избран победите в този търг
                    </div>
                </div>
                
                <rp-preview v-if='canStart || isOwner'></rp-preview>
                <ip-preview v-if='!canStart && !isOwner'></ip-preview>
            </div>
        </div>

    </div>

</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {
                
            // this.isOwner = this.user.id == this.$parent.project.user_id;
            this.newPhase = Object.assign({}, this.mdl);

        },

        data() {
            return {

                isReady : false,
                isOwner : false,
                canStart : false,
                showForm : false,

                page : "list",

                //Array with phase sub-phases
                subPhases : [],

                newPhase : false,

                mdl : {
                    
                    rid : null,
                    info  : '',
                    days  : 7,
                    p : this.$parent.p,
                    offers : 0,
                    previews : 0,

                },

                timerMessage : "Оставащо време за тръжната процедура",

                phList : [],

                validatorFields : [
                    { 
                        selector  : "#rid",
                        required : true,
                        customErr : 'Моля изберете тръжна процедура'
                    },
                    { 
                        selector  : "#days",
                        min       : 1,
                        customErr : 'Моля въведете брой дни'
                    }
                ]

            }
        },

        methods : {

            getData() { 

                var me = this;


                me.ajax.call('phs:gchp', { p : this.$parent.p }, (r) => {

                    if( r.status == 'success' ) {
                        
                        me.subPhases = r.data.sp;
                        me.phList    = r.data.pl;
                        me.canStart  = r.data.cs;
                        me.isOwner   = r.data.ow;

                    }

                    me.isReady = true;

                    me.readHash();
                })

            },

            openTP( tp ) {

                this.tp = tp;
                this.page = 'single';
                location.hash = 'project-tp-' + tp.id;

            },
 
            startPhase() { 

                var me = this;

                this.$refs.validator.validate({
                    resolve(){

                        me.ajax.call('phs:stchp', me.newPhase, (r) => {

                            if( r.status == 'success' ) {
                                
                                me.subPhases.push( r.data );
                                me.newPhase = Object.assign({}, me.mdl);

                                $.notify("Тръжната процедура беше стартирана успешно","success");

                                $("#info").summernote('code','');
                                
                                me.showForm = false;

                            }

                        })
                    }
                });

            },


            readHash() {
                var h = location.hash.split('-').pop();

                if( !isNaN(h) ) {

                    for( var i in this.subPhases ) {
                        
                        if( this.subPhases[i].id == h ) {


                            this.tp = this.subPhases[i];
                            this.page  = 'single';

                            return; 
                        }

                    }

                }
            }

        },

        components : {
            'rp-preview' : require('./RPreview.vue').default,
            'ip-preview' : require('./IPreview.vue').default,
        },

        watch : {
            page(n,o) {
                if( n == 'list' ) {
                    location.hash = 'project-tp';
                }
            },

            showForm(n,o) {
                if( n ) {
                    
                    this.$nextTick( () => {
                        this.initSummernote("#info");
                    })

                } 
            }
        }

    }
</script>
